import ApiService from "@/common/api.service";

const AccountService = {
    getMatchedUsersByIndustryCode(industryCode) {
        if (!industryCode) return Promise.resolve([]);

        return ApiService.post("/all-users-without-customers", {
            limit: 50,
            offset: 0,
            sortBy: "id",
            order: "ASC",
            searchKeyword: "",
            industry_code: String(industryCode)
        }).then(({ data }) => {
            const rows = data.user_list && data.user_list.rows;
            return rows && rows.length > 0 ? rows : [];
        });
    }
};

export default AccountService;
